
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 42 42","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M21.001.5C11.582.5 3.918 8.163 3.918 17.583c0 4.586 1.795 8.892 5.048 12.12l11.428 11.543a.852.852 0 001.215 0L33.03 29.71a16.97 16.97 0 005.054-12.126C38.085 8.163 30.42.5 21 .5zm0 23.917a6.84 6.84 0 01-6.833-6.834 6.84 6.84 0 016.833-6.833 6.84 6.84 0 016.834 6.833A6.84 6.84 0 0121 24.417z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"d":"M.5.5h41v41H.5V.5z","fill":"#fff"}})])])])
          )
        }
      }
    